// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"762":"bd38b063","978":"18baf71d"}[chunkId] + ".chunk.js";
};